module.exports = __webpack_public_path__ + "img/dante-canto.b648377f.jpg";